<template>
  <svg :width="width" :height="height" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.8517 1.23435C12.0319 1.08298 12.2597 1 12.495 1H37.6446C38.1968 1 38.6446 1.44772 38.6446 2V9.455C38.6446 9.99676 38.2131 10.44 37.6717 10.4546L37.6663 10.4548L37.6406 10.4557C37.6166 10.4567 37.5791 10.4583 37.5291 10.4609C37.4291 10.4662 37.2793 10.4754 37.0877 10.4912C36.704 10.5229 36.1549 10.5807 35.5035 10.6849C34.1932 10.8943 32.5058 11.2855 30.9267 12.0054C29.3435 12.7271 27.9434 13.745 27.0964 15.1672C26.2667 16.5606 25.894 18.4655 26.5841 21.1337L37.0731 61.6347C37.1506 61.9343 37.0852 62.2529 36.8958 62.4975C36.7064 62.7422 36.4144 62.8855 36.105 62.8855H3.00001C2.6906 62.8855 2.39861 62.7422 2.20922 62.4976C2.01984 62.2529 1.95438 61.9343 2.03194 61.6348L12.5196 21.1336C13.9242 15.7051 12.3292 12.4223 10.4984 10.4755C9.56043 9.47824 8.53176 8.80327 7.73344 8.3776C7.33579 8.16557 6.9999 8.01784 6.76796 7.92459C6.65215 7.87802 6.56272 7.84522 6.50503 7.82493C6.4762 7.81479 6.45534 7.80778 6.44313 7.80376L6.43144 7.79996C6.08219 7.69173 5.82058 7.40174 5.74805 7.04332C5.67546 6.68456 5.80468 6.31481 6.08493 6.07935L11.8517 1.23435ZM8.60371 6.57536C8.62711 6.58766 8.65069 6.60013 8.67445 6.6128C9.60974 7.11151 10.8304 7.90926 11.9553 9.10536C14.2501 11.5454 16.0348 15.5323 14.4559 21.6346L4.29194 60.8855H34.813L24.6479 21.6348C23.8468 18.5376 24.232 16.0683 25.3781 14.1439C26.5069 12.2484 28.3003 11.0047 30.0971 10.1856C31.898 9.36452 33.7769 8.93546 35.1879 8.70992C35.754 8.61942 36.2507 8.56078 36.6446 8.52293V3H12.8593L8.60371 6.57536Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.1883 10.4437C30.7406 10.4437 31.1883 10.8914 31.1883 11.4437C31.1883 16.9595 35.7068 21.4769 41.2229 21.4769V23.4769C34.6026 23.4769 29.1883 18.0644 29.1883 11.4437C29.1883 10.8914 29.636 10.4437 30.1883 10.4437Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.6812 19.5945C13.6812 19.0422 14.1289 18.5945 14.6812 18.5945H24.4244C24.9767 18.5945 25.4244 19.0422 25.4244 19.5945C25.4244 20.1467 24.9767 20.5945 24.4244 20.5945H14.6812C14.1289 20.5945 13.6812 20.1467 13.6812 19.5945Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.307 47.7612L30.0397 58.5053H9.05469L11.8283 47.7612H27.307Z"
      fill="#FF0064"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M46.8775 7C46.8775 8.1045 45.982 9 44.8775 9C43.773 9 42.8775 8.1045 42.8775 7C42.8775 5.8955 43.773 5 44.8775 5C45.982 5 46.8775 5.8955 46.8775 7Z"
      fill="#FF0064"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M54.275 7C54.275 8.1045 53.3795 9 52.275 9C51.1705 9 50.275 8.1045 50.275 7C50.275 5.8955 51.1705 5 52.275 5C53.3795 5 54.275 5.8955 54.275 7Z"
      fill="#FF0064"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M61.6724 7C61.6724 8.1045 60.7769 9 59.6724 9C58.5679 9 57.6724 8.1045 57.6724 7C57.6724 5.8955 58.5679 5 59.6724 5C60.7769 5 61.6724 5.8955 61.6724 7Z"
      fill="#FF0064"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'HousekeepingIllustration',
  props: {
    width: {
      type: Number,
      default: 64,
    },
    height: {
      type: Number,
      default: 64,
    },
  },
};
</script>
